// extracted by mini-css-extract-plugin
module.exports = {"ldsLoader":"Loader__ldsLoader__32ymL","wrapper":"Loader__wrapper__2ESBt","rot":"Loader__rot__PJbUp","scale":"Loader__scale__HPuu3"};